import { useQuery } from 'react-query';
import { getWallet, IGetWallet } from '../api/wallet';
import { IWallet } from '../types/IWallet';

interface IUseGetWalletResponse {
    walletData: IWallet;
    isLoading: boolean;
}
export function useGetWallet(params: IGetWallet): IUseGetWalletResponse {
    const { data: walletData, isLoading } = useQuery(['myWallet'], () => getWallet(params), {
        retry: false,
        staleTime: Infinity,
        cacheTime: 100,
    });
    return { walletData, isLoading };
}
